/* eslint-disable no-script-url */

import React, { useEffect } from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import MaterialTable from 'material-table'
import api from './../../services/axios'

// Generate Order Data
function createData(id, date, name, shipTo, paymentMethod, amount) {
  return { id, date, name, shipTo, paymentMethod, amount };
}

const rows = [
  createData(0, '16 Mar, 2019', 'Elvis Presley', 'Tupelo, MS', 'VISA ⠀•••• 3719', 312.44),
  createData(1, '16 Mar, 2019', 'Paul McCartney', 'London, UK', 'VISA ⠀•••• 2574', 866.99),
  createData(2, '16 Mar, 2019', 'Tom Scholz', 'Boston, MA', 'MC ⠀•••• 1253', 100.81),
  createData(3, '16 Mar, 2019', 'Michael Jackson', 'Gary, IN', 'AMEX ⠀•••• 2000', 654.39),
  createData(4, '15 Mar, 2019', 'Bruce Springsteen', 'Long Branch, NJ', 'VISA ⠀•••• 5919', 212.79),
];

const useStyles = makeStyles(theme => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function Usuarios({verMais}) {
  const classes = useStyles();

  const [data, setData] = React.useState([]);

  const loadData = async () => {
    const role='';
    const data = await api.get('/v1/users?perPage=5')
    setData(data.data.data)
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <React.Fragment>
      <Title>Usuários recentes</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Data</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Cidade</TableCell>
            <TableCell>Estado</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(data => (
            <TableRow key={data.id}>
              <TableCell>{data.createdAt}</TableCell>
              <TableCell>{data.name}</TableCell>
              <TableCell>{data.email}</TableCell>
              <TableCell>{data.city}</TableCell>
              <TableCell>{data.state}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/* <MaterialTable size="small"
        columns={[
          { title: 'Nome', field: 'name' },
          { title: 'Email', field: 'email' },
          { title: 'Cidade', field: 'city' },
          // { title: 'Estado', field: 'state', lookup: { 1: 'SP', 2: 'RJ' } }
          { title: 'Estado', field: 'state' },
          { title: 'Criação', field: 'createdAt' }
        ]}
        data={data}
        title=""
        options={{
          actionsColumnIndex: -1
        }}
      /> */}
      <div className={classes.seeMore}>
        <Link color="primary" onClick={()=> verMais() }>
          Ver mais
        </Link>
      </div>
    </React.Fragment>
  );
}
